import React from 'react';
import { CurveLine } from '@/components';

interface HeadingProps {
  title: string;
  className?: string;
  titleClassName?: string;
  isShowCurveLine?: boolean;
  size?: string;
  isWhite?: boolean;
  hasSubHeading?: boolean;
  subHeading?: string;
  justifyContent?: string;
}

function getHeadingSize(size: string): string {
  switch (size) {
    case 'lg':
      return 'text-5xl leading-[.85] md:text-6xl lg:text-7xl xl:text-8xl font-semibold lg:-tracking-[1px]';
    case 'sm':
      return 'text-5xl leading-[1] lg:text-6xl xl:text-7xl font-semibold';
    case 'xs':
      return 'text-4xl lg:text-5xl leading-[1] font-bold';
    default:
      return 'text-5xl leading-[1]] lg:text-6xl xl:text-7xl font-semibold';
  }
}

const SectionHeading: React.FC<HeadingProps> = ({
  title,
  className = '',
  titleClassName = '',
  isShowCurveLine = false,
  size = 'md',
  isWhite = false,
  hasSubHeading = false,
  subHeading = '',
  justifyContent = 'justify-start',
}) => {
  const headingClass = getHeadingSize(size);

  return (
    <div className={className}>
      {hasSubHeading && (
        <>
          <h3 className={`text-2xl leading-7 ${size == 'xs' ? 'font-normal' : 'font-semibold'}`}>
            {subHeading}
          </h3>
          {isShowCurveLine && (
            <div className='mb-4 mt-2.5'>
              <CurveLine
                className={`flex items-center ${justifyContent}`}
                isWhite={isWhite}
                hasUnderLine={false}
              />
            </div>
          )}
        </>
      )}
      <h1
        className={`font-halyarddisplay ${headingClass} ${isWhite ? 'text-white' : 'text-black'} ${titleClassName}`}
      >
        {title}
      </h1>
      {isShowCurveLine && !hasSubHeading && (
        <div className='mt-3'>
          <CurveLine
            className={`flex items-center ${justifyContent}`}
            isWhite={isWhite}
            hasUnderLine={false}
          />
        </div>
      )}
    </div>
  );
};

export default SectionHeading;
